import { render, staticRenderFns } from "./hello.vue?vue&type=template&id=65ca686a"
import script from "./hello.vue?vue&type=script&lang=js"
export * from "./hello.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports